/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const SavedFilterDTOTypeEnum = {
    Keyword: 'KEYWORD',
    Store: 'STORE',
    Search: 'SEARCH',
    ProductStaging: 'PRODUCT_STAGING',
    Inventory: 'INVENTORY'
};
/**
 * Check if a given object implements the SavedFilterDTO interface.
 */
export function instanceOfSavedFilterDTO(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function SavedFilterDTOFromJSON(json) {
    return SavedFilterDTOFromJSONTyped(json, false);
}
export function SavedFilterDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'type': json['type'] == null ? undefined : json['type'],
        'filter': json['filter'] == null ? undefined : json['filter'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
    };
}
export function SavedFilterDTOToJSON(json) {
    return SavedFilterDTOToJSONTyped(json, false);
}
export function SavedFilterDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
        'filter': value['filter'],
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
    };
}
